<template>
    <div v-if="permissionCheck('Leaves','Read')" class="container-fluid">
        <div class="row actions no-print">
            <div class="col-md-3 float-left">
                Home > Shift Plans
            </div>
            <div class="col-md-9">
                <button v-if="selectedShift" class="btn btn-danger float-right" style="margin-right: 5px;" @click="closeData"><icon name="times"></icon> Close Leave</button>
                <button v-if="permissionCheck('Leaves','Create')" class="btn btn-success float-right" style="margin-right: 5px;" @click="createDate"><icon name="plus"></icon> Create Leave</button>
                <button v-if="!selectedShift" style="float: right; margin-right: 5px;" class="btn btn-primary" @click="$refs.searchFilter.show()" type="button"><icon name="search"></icon> Search Leaves</button>

            </div>
        </div>

        <div class="row">
            <div class="col content">
                <h1 align="center"><icon name="envelope" scale="3"></icon> <br/> Leaves Management</h1>



                <!------------------------------------------------->
                <!--------------- Leaves Search Criterias --------->
                <!------------------------------------------------->
                <div class="row" style="background-color: rgba(0,0,0,0.03); padding: 5px;" v-if="searchFilters.isActive && !selectedShift && !newShift">
                    <div class="col-md-12" style="background-color: rgba(0,0,0,0.06); text-align: center; font-size: 18px; padding: 10px; border: 1px solid rgba(0,0,0,0.2);">
                        SEARCH CRITERIA
                    </div>


                    <div class="col-md-6" v-if="searchFilters.userID">
                        <div class="row">
                            <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Employees</strong></div>
                            <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                                <span v-for="data in searchFilters.userID"><b-badge variant="info">{{findUser(data).name}}</b-badge>&nbsp;</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6" v-if="searchFilters.leaveType">
                        <div class="row">
                            <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Leave Type</strong></div>
                            <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                                <span v-for="data in searchFilters.leaveType"><b-badge variant="warning">{{findLeaveType(data).name}}</b-badge>&nbsp;</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6" v-if="searchFilters.dateFrom">
                        <div class="row">
                            <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Date From</strong></div>
                            <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                                {{searchFilters.dateFrom}}
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6" v-if="searchFilters.dateTo">
                        <div class="row">
                            <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Date To</strong></div>
                            <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                                {{searchFilters.dateTo}}
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12" style="padding: 10px;">
                        <button style="float: right;" class="btn btn-secondary" @click="$refs.searchFilter.show()" type="button"><icon name="search"></icon> Modify Filter</button>
                        <button class="btn btn-success float-right" type="button" style="margin-right: 5px;" @click="searchFilterRecords('shift')"><icon name="calendar"></icon> Search Users</button>
                    </div>
                </div>

                <div v-if="dataList.length == 0 && !selectedShift && !newShift">
                    <p align="center">Currently there are no results for the requested search criteria</p>
                    <p align="center">Please use the search filter to find the records. </p>
                </div>


                <!------------------------------------------------->
                <!--------------- Leaves Listing Table------------->
                <!------------------------------------------------->

                <div v-if="dataList.length > 0 && !selectedShift && !newShift" class="row">

                    <!--Tickets List Table-->
                    <table class="table table-hover" style="margin-top: 10px;">
                        <thead>
                        <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Leave ID</th>
                        <th scope="col" style="font-size: 12px; min-width: 175px; background-color: #fffaf0;">Employee ID</th>
                        <th scope="col" style="font-size: 12px; min-width: 175px; background-color: #fffaf0;">Employee Name</th>
                        <th scope="col" style="font-size: 12px; min-width: 140px; background-color: #fffaf0;">Start Date</th>
                        <th scope="col" style="font-size: 12px; min-width: 140px; background-color: #fffaf0;">End Date</th>
                        <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Leave Type</th>
                        <th scope="col" style="font-size: 12px; background-color: #fffaf0;">Status</th>
                        <th class="no-print" scope="col" style="font-size: 12px; background-color: #fffaf0;"></th>
                        </thead>

                        <tbody>

                        <tr v-for="leave in dataList">
                            <td style="font-size: 12px; cursor: pointer;" @click="selectData(leave)">{{leave.id}}</td>
                            <td style="font-size: 12px; cursor: pointer;" @click="selectData(leave)">{{leave.users_id}}</td>
                            <td style="font-size: 12px; cursor: pointer;" @click="selectData(leave)">{{findUser(leave.users_id).name}}</td>
                            <td style="font-size: 12px; cursor: pointer;" @click="selectData(leave)">{{$moment(leave.dateFrom).format('ddd DD-MM-YYYY')}}</td>
                            <td style="font-size: 12px; cursor: pointer;" @click="selectData(leave)">{{$moment(leave.dateTo).format('ddd DD-MM-YYYY')}}</td>
                            <td style="font-size: 12px; cursor: pointer;" @click="selectData(shiftPlan)">{{findLeaveType(leave.leaveType).name}}</td>
                            <td style="font-size: 12px; cursor: pointer;" @click="selectData(leave)">
                                <span v-if="leave.status == 1" class='badge badge-success' style="font-size: 12px;">Active</span>
                            </td>
                            <td class="no-print" style="font-size: 12px; cursor: pointer;">
                                <button v-if="permissionCheck('Leaves','Update')" class="btn btn-sm btn-primary float-right" type="submit" style="margin-right: 5px;" @click="selectData(leave)"><icon name="refresh"></icon> Update Leave</button>
                                <button v-if="permissionCheck('Leaves','Delete')" class="btn btn-sm btn-danger float-right" type="button" style="margin-right: 5px;" @click="deleteData(leave)"><icon name="times"></icon> Delete</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <!--Pagination Links-->
                    <div class="col-md-12 standout" v-if="dataList.length > 0" v-show="!dataListLoading"  >
                        <div class="row">
                            <div class="col text-left" style="padding-top: 8px; font-size: 12px;">Total: {{timesheetsPaginationObject.totalRecords}} Applications</div>
                            <div class="col text-center" style="min-width: 200px; font-size: 12px;">
                                <button @click="updateRecordsList(1)" :disabled="!timesheetsPaginationObject.firstActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"><icon name="angle-double-left"></icon></button>
                                <button @click="updateRecordsList(timesheetsPaginationObject.currentPage-1)" :disabled="!timesheetsPaginationObject.previousActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-left"></icon> </button>
                                &nbsp; {{timesheetsPaginationObject.currentPage}} of {{timesheetsPaginationObject.totalPages}} &nbsp;
                                <button @click="updateRecordsList(timesheetsPaginationObject.currentPage+1)" :disabled="!timesheetsPaginationObject.nextActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-right"></icon> </button>
                                <button @click="updateRecordsList(timesheetsPaginationObject.totalPages)" :disabled="!timesheetsPaginationObject.lastActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-double-right"></icon> </button>
                            </div>
                            <div class="col text-right" style="float:right;">
                                <select v-model="sorting.limit" class="form-control" style="max-width: 140px; float: right;">
                                    <option :value="10">10 Per Page</option>
                                    <option :value="20">20 Per Page</option>
                                    <option :value="30">30 Per Page</option>
                                    <option :value="40">40 Per Page</option>
                                    <option :value="50">50 Per Page</option>
                                </select>
                                <button class="btn btn-success float-right" type="submit" style="margin-right: 5px; margin-top: 5px;" @click="exportCSV('leavesCSV')"><icon name="file"></icon> Export</button>
                            </div>
                        </div>
                    </div>

                </div>


                <!------------------------------------------------->
                <!-------------- Leaves Details Section ----------->
                <!------------------------------------------------->

                <div v-if="selectedShift" class="container shadows" style="padding: 30px; margin-top: 30px;">
                    <form @submit.prevent="onDataSave">
                        <h4 class="text-primary" align="center">Leave Application<br/> &nbsp;</h4>
                        <div class="row form-group">
                            <div class="col-md-2" style="padding-top: 3px;">
                                <strong>Application ID:</strong>
                            </div>
                            <div class="col-md-4">
                                {{selectedShift.id}}
                            </div>
                            <div class="col-md-2" style="padding-top: 3px;">
                                <strong>Application Date:</strong>
                            </div>
                            <div class="col-md-4">
                                {{$moment(selectedShift.created_at).format('D MMM, YYYY - dddd')}}
                            </div>
                        </div>
                        <div class="row form-group" style="margin-top: 25px;">
                            <div class="col-md-2">
                                <strong>Employee Name:</strong>
                            </div>
                            <div class="col-md-4">
                                {{selectedShift.users_id}} - {{findUser(selectedShift.users_id).name}}
                            </div>
                            <div class="col-md-2">
                                <strong>Leave Type:</strong>
                            </div>
                            <div class="col-md-4">
                                <multiselect
                                        v-model="multiSelect.leaveTypeUpdate"
                                        :disabled="disabled"
                                        @input="onSelectUpdateLeaveType"
                                        :options="leaveTypes"
                                        :allow-empty="false"
                                        placeholder="Select Leave Type"
                                        label="name" track-by="id">
                                </multiselect>
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-2">
                                <strong>Date From:</strong>
                            </div>
                            <div class="col-md-4">
                                <date-picker
                                        v-model="dateSelect.leaveDateFrom2"
                                        :disabled="disabled"
                                        type="date"
                                        @change="setDateFrom"
                                        :placeholder = "shiftUpdateForm.dateFrom"
                                        format="dd-MM-yyyy"
                                        :time-picker-options="{start: '08:00',step: '00:30',end: '18:30'}"
                                        lang="en" >
                                </date-picker>
                            </div>
                            <div class="col-md-2">
                                <strong>Date To:</strong>
                            </div>
                            <div class="col-md-4">
                                <date-picker
                                        v-model="dateSelect.leaveDateTo2"
                                        :disabled="disabled"
                                        type="date"
                                        @change="setDateTo"
                                        :placeholder = "shiftUpdateForm.dateTo"
                                        format="dd-MM-yyyy"
                                        :time-picker-options="{start: '08:00',step: '00:30',end: '18:30'}"
                                        lang="en">
                                </date-picker>
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-12"><strong>Leave Description:</strong></div>
                            <div class="col-md-12">
                                <textarea :disabled="disabled" class="form-control" rows="7" v-model="shiftUpdateForm.description" style="width:100%;"></textarea>
                            </div>
                        </div>


                        <div class="row form-group no-print">
                            <div class="col-md-12">
                                <button v-if="permissionCheck('Leaves','Update')" class="btn btn-success float-right" type="submit" style="margin-right: 5px;"><icon name="save"></icon> Update Application</button>
                                <button class="btn btn-danger float-right" @click="cancelNewData" type="button" style="margin-right: 5px;"><icon name="times"></icon> Close</button>
                            </div>
                        </div>
                    </form>

                </div>


                <!------------------------------------------------->
                <!-------------- Create New Leave Form ------------>
                <!------------------------------------------------->

                <div v-if="permissionCheck('Leaves','Read') && newShift" class="container shadows" style="padding: 30px; margin-top: 30px;">
                    <form @submit.prevent="onDataSave">
                        <h4 class="text-primary" align="center">Leave Application<br/> &nbsp;</h4>
                        <div class="row form-group">
                            <div class="col-md-2" style="padding-top: 3px;">
                                <strong>Application ID:</strong>
                            </div>
                            <div class="col-md-4">
                                {To be generated}
                            </div>
                            <div class="col-md-2" style="padding-top: 3px;">
                                <strong>Application Date:</strong>
                            </div>
                            <div class="col-md-4">
                                {{$moment().format('D MMM, YYYY - dddd')}}
                            </div>
                        </div>
                        <div class="row form-group" style="margin-top: 25px;">
                            <div class="col-md-2">
                                <strong>Employee Name:</strong>
                            </div>
                            <div class="col-md-2">
                                <multiselect
                                    v-model="multiSelect.employeeIDCreate"
                                    :options="users"
                                    :multiple="false"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :hide-selected="true"
                                    :preserve-search="true"
                                    placeholder="Search By ID"
                                    @input="onSelectCreateEmployeeID"
                                    label="id"
                                    track-by="id"
                                    :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
<!--                                        <span>{{ props.option.id }} - {{ props.option.name }}</span>-->
                                        <!--                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>-->
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.id }} - {{ props.option.name }}
                                    </template>
                                </multiselect>
                            </div>
                            <div class="col-md-2">

                                <multiselect
                                    v-model="multiSelect.employeeIDCreate"
                                    :options="users"
                                    :multiple="false"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :hide-selected="true"
                                    :preserve-search="true"
                                    placeholder="Search By Name"
                                    @input="onSelectCreateEmployeeID"
                                    label="name"
                                    track-by="name"
                                    :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.id }} - {{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.id }} - {{ props.option.name }}
                                    </template>
                                </multiselect>

                            </div>
                            <div class="col-md-2">
                                <strong>Leave Type:</strong>
                            </div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="multiSelect.leaveTypeCreate"
                                    @input="onSelectCreateLeaveType"
                                    :options="leaveTypes"
                                    placeholder="Select Leave Type"
                                    label="name" track-by="id">
                                </multiselect>
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-2">
                                <strong>Date From:</strong>
                            </div>
                            <div class="col-md-4">
                                <date-picker
                                    v-model="dateSelect.dateFrom1"
                                    type="date"
                                    @change="setDateFromCreate"
                                    :placeholder = "dataCreateForm.startDate"
                                    format="dd-MM-yyyy"
                                    :time-picker-options="{start: '08:00',step: '00:30',end: '18:30'}"
                                    lang="en" >
                                </date-picker>
                            </div>
                            <div class="col-md-2">
                                <strong>Date To:</strong>
                            </div>
                            <div class="col-md-4">
                                <date-picker
                                    v-model="dateSelect.dateTo1"
                                    type="date"
                                    @change="setDateToCreate"
                                    :placeholder = "dataCreateForm.endDate"
                                    format="dd-MM-yyyy"
                                    :time-picker-options="{start: '08:00',step: '00:30',end: '18:30'}"
                                    lang="en">
                                </date-picker>
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-12"><strong>Leave Description:</strong></div>
                            <div class="col-md-12">
                                <textarea class="form-control" rows="7" v-model="dataCreateForm.description" style="width:100%;"></textarea>
                            </div>
                        </div>


                        <div class="row form-group no-print">
                            <div class="col-md-12">
                                <button class="btn btn-success float-right" type="submit" style="margin-right: 5px;"><icon name="save"></icon> Create Leave Application</button>
                                <button v-if="newShift" class="btn btn-danger float-right" @click="cancelNewData" type="button" style="margin-right: 5px;"><icon name="save"></icon> Cancel</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- Search Filter Modal -->
        <form @submit.prevent="onSearchFilters">
            <b-modal ref="searchFilter" size="lg" centered >
                <div slot="modal-header">
                    <h3>Leave Applications: Search Filter</h3>
                </div>

                <b-container fluid>

                    <div class="form-group row">
                        <div class="col">
                            <small class="form-text text-muted"> <icon name="users"></icon> <strong>Employee</strong></small>
                            <multiselect
                                    v-model="searchFilters.userID2"
                                    :options="users"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="true"
                                    :hide-selected="true"
                                    :preserve-search="true"
                                    placeholder="Search By ID"
                                    @input="onSelectUserID"
                                    label="id"
                                    track-by="id"
                                    :preselect-first="false">
                                <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.id }}</span>
<!--                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>-->
                                    </span>
                                </template>
                                <template slot="option" slot-scope="props">
                                    {{ props.option.id }} - {{ props.option.name }}
                                </template>
                            </multiselect>
                            <multiselect
                                    v-model="searchFilters.userID2"
                                    :options="users"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="true"
                                    :hide-selected="true"
                                    :preserve-search="true"
                                    placeholder="Search By Name"
                                    @input="onSelectUserID"
                                    label="name"
                                    track-by="name"
                                    :preselect-first="false">
                                <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.id }} - {{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                </template>
                                <template slot="option" slot-scope="props">
                                    {{ props.option.id }} - {{ props.option.name }}
                                </template>
                            </multiselect>
                        </div>


                        <div class="col">
                            <small class="form-text text-muted"> <icon name="building"></icon> <strong>Leave Type</strong></small>
                            <multiselect
                                    v-model="searchFilters.leaveType2"
                                    :options="leaveTypes"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="true"
                                    :hide-selected="true"
                                    :preserve-search="true"
                                    placeholder=""
                                    @input="onSelectLeaveType"
                                    label="name"
                                    track-by="name"
                                    :preselect-first="false">
                                <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                </template>
                                <template slot="option" slot-scope="props">
                                    {{ props.option.name }}
                                </template>
                            </multiselect>
                        </div>
                    </div>


                    <div class="form-group row">
                        <div class="col">
                            <small class="form-text text-muted"> <icon name="calendar"></icon> <strong>Date From</strong></small>
                            <date-picker
                                    v-model="searchFilters.dateFrom2"
                                    type="date"
                                    @change="setDateFromSearch"
                                    :placeholder = "searchFilters.dateFrom"
                                    format="dd-MM-yyyy"
                                    :time-picker-options="{start: '08:00',step: '00:30',end: '18:30'}"
                                    lang="en">
                            </date-picker>
                        </div>

                        <div class="col">
                            <small class="form-text text-muted"> <icon name="calendar"></icon> <strong>Date To</strong></small>
                            <date-picker
                                    v-model="searchFilters.dateTo2"
                                    type="date"
                                    @change="setDateToSearch"
                                    :placeholder = "searchFilters.dateTo"
                                    format="dd-MM-yyyy"
                                    :time-picker-options="{start: '08:00',step: '00:30',end: '18:30'}"
                                    lang="en">
                            </date-picker>
                        </div>
                    </div>

                </b-container>

                <div slot="modal-footer">
                    <button class="btn btn-success float-right" type="submit" style="margin-right: 5px;" @click="searchFilterRecords('shift')"><icon name="users"></icon> Search Leaves</button>
                    <button class="btn btn-dark float-right" type="reset" style="margin-right: 5px;" @click="searchFilterClear('open')"><icon name="minus-square"></icon> Clear Filters</button>
                    <button class="btn btn-danger float-right" type="button" style="margin-right: 5px;" @click="$refs.searchFilter.hide()"><icon name="times"></icon> Cancel</button>
                </div>
            </b-modal>
        </form>


    </div>
</template>

<script>
    import axios from 'axios'
    import router from './../../../router'
    import {Form, Errors} from '@/components/validations/forms';
    import {mixin} from '@/mixins/mixins';

    export default {
        mixins: [mixin],
        name: 'AlertsZone',
        data () {
            return {
                disabled: true,
                users: this.$store.getters['user/getUsers'],
                selectedShift: null,
                newShift: false,
                leaveTypes: this.$store.getters['leaves/getLeaveTypes'],

                // User Filter
                dataList: [],
                timesheetsPages: null,
                timesheetsPaginationObject: {
                    totalRecords : 0,
                    totalPages : 0,
                    currentPage : 0,
                    first : 0,
                    firstActive : false,
                    previous : 0,
                    previousActive : false,
                    next : 0,
                    nextActive : false,
                    last : 0,
                    lastActive : false,
                },
                searchFilters: this.$store.getters['leaves/getSearchFilters'],
                sorting: this.$store.getters['leaves/getSorting'],
                dropdownx: this.$route.hash.substring(1),
                resultsView: "shift",


                dataCreateForm: new Form({
                    leaveType: null,
                    dateFrom: null,
                    dateTo: null,
                    userID: null,
                    description: null,
                }),

                shiftUpdateForm: new Form({
                    id: null,
                    leaveType: null,
                    dateFrom: null,
                    dateTo: null,
                    description: null,
                }),

                timePickerOptions: [
                    '00:00:00','00:30:00','01:00:00','01:30:00','02:00:00','02:30:00','03:00:00','03:30:00','04:00:00','04:30:00','05:00:00','05:30:00','06:00:00','06:30:00','07:00:00','07:30:00','08:00:00','08:30:00',
                    '09:00:00','09:30:00','10:00:00','10:30:00','11:00:00','11:30:00','12:00:00','12:30:00','13:00:00','13:30:00','14:00:00','14:30:00','15:00:00','15:30:00','16:00:00','16:30:00','17:00:00','17:30:00',
                    '18:00:00','18:30:00','19:00:00','19:30:00','20:00:00','20:30:00','21:00:00','21:30:00','22:00:00','22:30:00','23:00:00','23:30:00'
                ],
            }
        },

        methods: {

            selectData(shift){
                if(this.permissionCheck('Leaves','Update')){this.disabled = false;}
                this.selectedShift = shift;
                this.shiftUpdateForm.id = shift.id;
                this.shiftUpdateForm.leaveType = shift.leaveType;
                this.shiftUpdateForm.dateFrom = shift.dateFrom;
                this.shiftUpdateForm.startDate = shift.startDate;
                this.shiftUpdateForm.dateTo = shift.dateTo;
                this.shiftUpdateForm.description = shift.description;
                this.multiSelect.leaveTypeUpdate = this.findLeaveType(shift.leaveType);

            },

            closeData(){
                this.selectedShift = null;
                this.resetShiftUpdateForm();
            },

            resetShiftUpdateForm(){
                this.shiftUpdateForm.id = null;
            },

            onDataSave(){
                if(this.selectedShift){
                    if(
                        this.shiftUpdateForm.dateFrom &&
                        this.shiftUpdateForm.dateTo &&
                        this.shiftUpdateForm.leaveType &&
                        this.shiftUpdateForm.dateFrom <= this.shiftUpdateForm.dateTo){
                        this.updateData();
                    } else{this.$snotify.error("Please make sure you have selected the leave type and the correct Start Date / End Date");}

                } else{
                    if(
                        this.dataCreateForm.dateFrom &&
                        this.dataCreateForm.dateTo &&
                        this.dataCreateForm.userID &&
                        this.dataCreateForm.leaveType &&
                        this.dataCreateForm.dateFrom <= this.dataCreateForm.dateTo
                    ){
                        this.saveData();
                    } else{this.$snotify.error("Please make sure you have selected the employee, leave type and chosen the correct Start/End Date");}
                }
            },

            updateData(){
                this.$store.dispatch('leaves/updateLeave', this.shiftUpdateForm)
                    .then(response => {
                        this.$snotify.success('Leave Application Saved');
                        this.updateRecordsList();
                        this.closeData();
                    })
                    .catch(error => {
                        this.shiftUpdateForm.onFail(error);
                        this.$snotify.error(this.shiftUpdateForm.errors.error.message, this.shiftUpdateForm.errors.error.title);
                    })

            },

            createDate(){
                this.newShift = true;
                this.selectedShift = null;
            },

            saveData(){

                this.$store.dispatch('leaves/storeLeave', this.dataCreateForm)
                    .then(response => {
                        this.updateRecordsList();
                        this.newShift = false;
                        this.$snotify.success('Leave Application Saved');
                    })
                    .catch(error => {
                        this.dataCreateForm.onFail(error);
                        this.$snotify.error(this.dataCreateForm.errors.error.message, this.dataCreateForm.errors.error.title);
                    })
            },

            deleteData(shift){
                if(confirm("Do you really want to delete?")) {
                    this.$store.dispatch('leaves/deleteLeave', shift)
                        .then(response => {
                            this.$snotify.success('Leave Application Deleted');
                            this.updateRecordsList();
                        })
                        .catch(error => {
                            this.shiftUpdateForm.onFail(error);
                            this.$snotify.error(this.shiftUpdateForm.errors.error.message, this.shiftUpdateForm.errors.error.title);
                        })
                }
            },

            exportCSV(view){
                this.timesheetsListLoading = true;
                return axios.request({
                    method: 'GET',
                    responseType: 'blob',
                    url: '/api/attendance/leave',
                    params: {
                        companies: this.searchFilters.companies,
                        sponsorCompanies: this.searchFilters.sponsorCompanies,
                        branches: this.searchFilters.branches,
                        departments: this.searchFilters.departments,
                        cities: this.searchFilters.cities,
                        nationalities: this.searchFilters.nationalities,
                        designations: this.searchFilters.designations,
                        religions: this.searchFilters.religions,
                        shiftPlans: this.searchFilters.shiftPlans,
                        dateFrom: this.searchFilters.dateFrom,
                        dateTo: this.searchFilters.dateTo,
                        employees: this.searchFilters.employees,
                        resultsView: view,
                        limit: this.sorting.limit,
                        page: this.sorting.page,
                        sortBy: this.sorting.sortBy,
                        sortOrder: this.sorting.sortOrder,
                    },

                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Leaves Report ('+this.searchFilters.dateFrom+' - '+this.searchFilters.dateTo+').csv');
                    document.body.appendChild(link);
                    link.click();
                    this.timesheetsListLoading = false;

                })
                    .catch(error => {
                        this.timesheetsListLoading = false;
                    });
            },

            cancelNewData(){
                this.newShift = false;
                this.selectedShift = null;
            },

            setDateFrom(){
                if(this.dateSelect.leaveDateFrom2){
                    this.shiftUpdateForm.dateFrom = this.$moment(this.dateSelect.leaveDateFrom2).format('YYYY-MM-DD');
                } else{this.shiftUpdateForm.dateFrom = this.$moment().format('YYYY-MM-DD')}
            },

            setDateTo(){
                if(this.dateSelect.leaveDateTo2){
                    this.shiftUpdateForm.dateTo = this.$moment(this.dateSelect.leaveDateTo2).format('YYYY-MM-DD');
                } else{this.shiftUpdateForm.dateTo = this.$moment().format('YYYY-MM-DD')}
            },

            setDateFromCreate(){
                if(this.dateSelect.dateFrom1){
                    this.dataCreateForm.dateFrom = this.$moment(this.dateSelect.dateFrom1).format('YYYY-MM-DD');
                } else{this.dataCreateForm.dateFrom = this.$moment().format('YYYY-MM-DD')}
            },

            setDateToCreate(){
                if(this.dateSelect.dateTo1){
                    this.dataCreateForm.dateTo = this.$moment(this.dateSelect.dateTo1).format('YYYY-MM-DD');
                } else{this.dataCreateForm.dateTo = this.$moment().format('YYYY-MM-DD')}
            },

            setDateFromSearch(value){
                this.searchFilters.dateFrom = this.$moment(value).format('YYYY-MM-DD')
                // if(this.dateSelect.leaveDateFrom){
                //     this.searchFilters.dateFrom = this.$moment(this.dateSelect.leaveDateFrom).format('YYYY-MM-DD');
                // } else{this.searchFilters.dateFrom = this.$moment(value).format('YYYY-MM-DD')}
            },

            setDateToSearch(value){
                this.searchFilters.dateTo = this.$moment(value).format('YYYY-MM-DD')
                // if(this.dateSelect.leaveDateTo){
                //     this.searchFilters.dateTo = this.$moment(this.dateSelect.leaveDateTo).format('YYYY-MM-DD');
                // } else{this.searchFilters.dateTo = this.$moment().format('YYYY-MM-DD')}
            },

            ////////////////////////////////////////////////////
            // Search Filter Form
            ////////////////////////////////////////////////////
            // Multi List Dropdown Cleanup Functions Based
            ////////////////////////////////////////////////////
            // These methods clean up objects of selected options and make an array of IDs in search filter form
            onSelectUserID(value){this.searchFilters.userID = value.map(a => a.id);},
            onSelectLeaveType(value){this.searchFilters.leaveType = value.map(a => a.id);},
            onSelectCreateEmployeeID(value){this.dataCreateForm.userID = value.id;},
            onSelectCreateLeaveType(value){this.dataCreateForm.leaveType = value.id;},
            onSelectUpdateLeaveType(value){this.shiftUpdateForm.leaveType = value.id;},

            // This method clears the search filter popup and fetches in new records based on criteria
            searchFilterRecords(view){
                this.searchFilters.shiftPlans = this.selectedShift;
                this.searchFilters.resultsView = view;
                this.searchFilters.isActive = true;
                this.$refs.searchFilter.hide();
                this.updateRecordsList();
            },
            // This method clears the search filter results and selected criteria load default open tickets page
            searchFilterClear(redirect){
                this.searchFilters = JSON.parse(JSON.stringify(this.$store.getters['leaves/getDefaultSearchFilters']));
                this.dateSelect = {};
                this.searchFilters.isActive = false;
                this.dataList = [];
                this.multiSelect.leaveUsers = null;
                this.multiSelect.leaveType = null;
                this.$refs.searchFilter.hide()
            },
            // This method will perform functions once the search filter form is submitted.
            onSearchFilters(){
                //
            },
            // Helper functions to select the objects by searching through ID

            // Update Tickets Pagination Object
            updateTicketsPaginationObject(){
                let paginationObject = null;

                let totalRecords = 0;
                let totalPages = 1;
                let currentPage = 1;
                let first = 1;
                let firstActive = false;
                let previous = 1;
                let previousActive = false;
                let next = 1;
                let nextActive = false;
                let last = 1;
                let lastActive = false;

                if(this.timesheetsPages['meta']){paginationObject = this.timesheetsPages['meta'];}
                if(paginationObject){
                    totalRecords = paginationObject.total;
                    totalPages = paginationObject.last_page;
                    currentPage = paginationObject.current_page;
                    first = 1;
                    if(currentPage > 1){previous = currentPage - 1;} else{previous = 1}
                    if(currentPage < totalPages){next = currentPage + 1;} else{next = totalPages}
                    last = paginationObject.last_page;

                    if(totalPages === 1){firstActive = false; previousActive = false; nextActive = false; lastActive = false;}
                    else{
                        if(currentPage > previous){firstActive = true; previousActive = true;}
                        if(currentPage < next){nextActive = true; lastActive = true;}
                        if(currentPage < next && currentPage > previous){firstActive = true; previousActive = true; nextActive = true; lastActive = true;}
                        if(currentPage === first){firstActive = false; previousActive = false; nextActive = true; lastActive = true;}
                        if(currentPage === last){firstActive = true; previousActive = true; nextActive = false; lastActive = false;}

                    }
                }

                this.timesheetsPaginationObject = {
                    totalRecords: totalRecords,
                    totalPages: totalPages,
                    currentPage: currentPage,
                    first: first,
                    firstActive: firstActive,
                    previous: previous,
                    previousActive: previousActive,
                    next: next,
                    nextActive: nextActive,
                    last: last,
                    lastActive: lastActive,
                };
                // if(this.timesheetsPaginationObject.currentPage > 1) {
                //     this.numbers = ((this.timesheetsPaginationObject.currentPage - 1) * this.sorting.limit) + 1;
                // }
                // if(this.timesheetsPaginationObject.currentPage === this.timesheetsPaginationObject.last){
                //
                // }
                // else{ this.nunmbers = 1;}
            },
            // This method will be triggered whenever tickets list array needs to fetch in fresh tickets from the server
            updateRecordsList(page){
                this.selectedEmployee = {};
                this.dataListLoading = true;
                if(!page){page = 1;}
                this.sorting.page = page;

                // if(this.searchFilters.isActive){
                    this.$store.dispatch('leaves/fetchTimesheetUsers', {filters: this.searchFilters, sorting: this.sorting})
                        .then(response => {
                            this.dataList = this.$store.getters['leaves/getTimesheetUsers'];
                            this.timesheetsPages = this.$store.getters['leaves/getTimesheetPages'];
                            this.dataListLoading = false;
                            this.updateTicketsPaginationObject();

                        })
                        .catch(error => {
                            this.dataListLoading = false;
                        })
                // }
            },


            loadRecords(){
                // Load Leaves
                this.$store.dispatch('leaves/fetchTimesheetUsers')
                    .then(response => {this.dataList = this.$store.getters['leaves/getLeaves'];})
            },

            loadRecordsData() {
                this.loadRecords()
                this.updateRecordsList();
                this.resetShiftUpdateForm()
            },

        },

        computed: {
            // Find Shift ID
            shiftID(){
                if(this.selectedShift){return this.selectedShift.id} else{return null;}
            },

            pageLimit(){
                return this.sorting.limit;
            },
        },

        watch: {
            // Watch Pagination Changes
            timesheetsPages: function(newValue, oldValue){
                if(newValue){this.updateTicketsPaginationObject();}
            },
            pageLimit(newValue, oldValue){
                if(newValue !== oldValue){this.updateRecordsList();}
            },
        },

        created() {
            this.searchFilters = this.$store.getters['leaves/getSearchFilters'];
            this.sorting = this.$store.getters['leaves/getSorting'];
            this.loadRecordsData();
        },

        beforeDestroy() {
            this.$store.dispatch('leaves/resetSearchFilters');
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/hr/leaves/leaves.vue